/** Aislamiento de datos locales por emisor y usuario. No valida permisos del API. */
export function ambitoActual() {
  try {
    const token = localStorage.getItem('gth_auth_token');
    if (!token) return null;
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(payload));
    if (!claims.sub || !claims.iss) return null;
    return encodeURIComponent(`${claims.iss}|${claims.sub}`);
  } catch { return null; }
}
export function nombrePrivado(prefijo) {
  const ambito = ambitoActual();
  return `${prefijo}-v2-${ambito ?? 'sin-sesion'}`;
}
export function exigirMismaCuenta(ambito) {
  if (ambitoActual() !== ambito) throw new Error('La sesión cambió durante la operación. Vuelve a intentarlo.');
}
